import { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowLeft, ArrowRight, Briefcase, MapPin, Check, Sparkles } from 'lucide-react';
import { getRole, roles, applyLink, APPLY_EMAIL } from '../data/roles';
import './JoinUs.css';

const RoleDetail = () => {
  const { slug } = useParams();
  const role = getRole(slug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!role) {
    return (
      <div className="careers-page">
        <div className="container careers-hero">
          <h1>Role not found</h1>
          <p>This position doesn't exist or is no longer open.</p>
          <Link to="/join" className="btn btn-primary btn-lg">See all roles</Link>
        </div>
      </div>
    );
  }

  const others = roles.filter((r) => r.slug !== role.slug);

  return (
    <>
      <title>{`${role.title} - Careers - Pidesk`}</title>
      <meta name="description" content={role.short} />

      <div className="careers-page">
        <div className="container role-wrap">
          <Link to="/join" className="back-link"><ArrowLeft size={16} /> All positions</Link>

          <header className="role-hero">
            <span className="careers-eyebrow">{role.type}</span>
            <h1>{role.title}</h1>
            <p>{role.short}</p>
            <div className="role-meta role-meta-lg">
              <span><Briefcase size={15} /> {role.type}</span>
              <span><MapPin size={15} /> {role.place}</span>
            </div>
            <a href={applyLink(role.title)} className="btn btn-primary btn-lg role-apply">
              Apply for this role <ArrowRight size={18} style={{ marginLeft: 8 }} />
            </a>
          </header>

          <div className="role-layout">
            <div className="role-body">
              <section>
                <h2>About the role</h2>
                <p className="role-about">{role.about}</p>
              </section>

              <section>
                <h2>What you'll do</h2>
                <ul className="role-list-check">
                  {role.responsibilities.map((t) => <li key={t}><Check size={16} /> {t}</li>)}
                </ul>
              </section>

              <section>
                <h2>What we're looking for</h2>
                <ul className="role-list-check">
                  {role.requirements.map((t) => <li key={t}><Check size={16} /> {t}</li>)}
                </ul>
              </section>

              {role.niceToHave.length > 0 && (
                <section>
                  <h2>Nice to have</h2>
                  <ul className="role-list-check nice">
                    {role.niceToHave.map((t) => <li key={t}><Sparkles size={16} /> {t}</li>)}
                  </ul>
                </section>
              )}
            </div>

            <aside className="role-side">
              <div className="side-box">
                <h3>How to apply</h3>
                <p>Send us your resume, portfolio or GitHub link. Tell us a little about yourself and why this role.</p>
                <a href={applyLink(role.title)} className="btn btn-primary">Apply by email</a>
                <a className="role-mail" href={`mailto:${APPLY_EMAIL}`}>{APPLY_EMAIL}</a>
              </div>

              {others.length > 0 && (
                <div className="side-box">
                  <h3>Other positions</h3>
                  <ul className="other-roles">
                    {others.map((r) => (
                      <li key={r.slug}>
                        <Link to={`/join/${r.slug}`}>
                          <span>{r.title}</span>
                          <ArrowRight size={14} />
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </aside>
          </div>
        </div>
      </div>
    </>
  );
};

export default RoleDetail;
